<template>
  <section class="container">
    <el-form label-width="100px">
      <el-form-item label="标题">
        <!-- <el-input v-model="editObject.style_title"/> -->
        <span v-text="editObject.style_title"/>
      </el-form-item>
      <el-form-item label="描述">
        <!-- <el-input v-model="editObject.style_desc"/> -->
        <span v-text="editObject.style_desc"/>
      </el-form-item>
      <el-form-item label="权重">
        <!-- <el-input v-model="editObject.style_sort"/> -->
        <span v-text="editObject.style_sort"/>
      </el-form-item>
      <el-form-item label="图片">
        <img
          v-if="editObject.style_img"
          :src="qiniuDomain + editObject.style_img"
          class="avatar">
      </el-form-item>
      <el-form-item label="banner">
        <div
          v-for="(item, index) in editObject.banner"
          :key="index"
          class="banner-box">
          <img
            :src="qiniuDomain + item.style_carousel_img"
            class="banner-img" >
        </div>
      </el-form-item>
    </el-form>
  </section>
</template>

<script>
import getQiniuInfo from '@/api/api'
import env from '@/configs/env'
import {
  styleDetail,
} from '@/api/style'

export default {
  data() {
    return {
      uploadDomain: env.uploadDomain,
      uploadData: {
        token: '',
      },
      qiniuDomain: '',
      editObject: { //  根据接口来的命名，不是很喜欢---
        style_title: '',
        style_img: '',
        style_sort: '',
        style_desc: '',
        banner: [],
        // uuid: '',
      },
    };
  },

  created() {
    this.network().getQiniuInfo()
    this.network().styleDetail()
  },
  methods: {
    network() {
      return {
        getQiniuInfo: async () => {
          const { status, data } = await getQiniuInfo()
          if (status === 200) {
            this.uploadData.token = data.token
            this.qiniuDomain = data.BucketDomain
          }
        },
        styleDetail: async () => {
          const { status, data } = await styleDetail({
            uuid: this.$route.params.uuid,
          })
          if (status === 200) {
            this.editObject.style_title = data.style_title
            this.editObject.style_sort = data.style_sort
            this.editObject.style_img = data.style_img
            this.editObject.style_desc = data.style_desc
            // this.editObject.uuid = data.uuid
            // this.editObject.banner = data.banner || []
            const oBanner = []
            data.banner.forEach((item) => {
              oBanner.push({
                style_carousel_img: item.style_carousel_img,
              })
            })
            this.editObject.banner = oBanner
          }
        },
      }
    },
  },
};
</script>

<style scoped>
.btn-group {
  margin-bottom: 20px;
  text-align: right;
}
.add-btn {
    margin-left: auto;
  }
.avatar-uploader .el-upload {
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    border: 1px dashed #d9d9d9;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  .banner-box {
    position: relative;
    margin-right: 20px;
    display: inline-block;
    width: 200px;
    height: 100px;
  }
  .banner-box .icon {
    position: absolute;
    top: 5px;
    right: 5px;
    z-index: 2;
    width: 20px;
    height: 20px;
    line-height: 20px;
    font-size: 20px;
    cursor: pointer;
  }
  .banner-img {
    width: 200px;
    height: 100px;
  }
</style>



// WEBPACK FOOTER //
// src/vuepage/style/style-detail.vue